module.exports = __webpack_public_path__ + "static/media/news-horizontal-card.0d2406ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news-horizontal-card.png
// module id = 1004
// module chunks = 0